import React from 'react';
import {IndexLink, Link} from 'react-router';
import * as commonApi from '../../../api/common-api';
import * as courseApi from '../../../api/course-api';
import {connect} from 'react-redux';
import Loading from 'react-loading';
import axios from 'axios';

var querystring = require('querystring');
import Textarea from 'react-textarea-autosize';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

import ReactDOM from 'react-dom';

var genderOptions = [
    {value: '0', label: 'Male'},
    {value: '1', label: 'Female'},
];
var carOptions = [
    {value: '0', label: 'No, I don\'t have a car on campus'},
    {value: '1', label: 'Yes, I have a car on campus'},
];
var ethOptions = [
    {value: 'Undisclosed', label: 'Undisclosed'},
    {value: 'American Indian or Alaska Native', label: 'American Indian or Alaska Native'},
    {value: 'Asian', label: 'Asian'},
    {value: 'Black or African American', label: 'Black or African American'},
    {value: 'Hispanic or Latino', label: 'Hispanic or Latino'},
    {value: 'Native Hawaiian or Other Pacific Islander', label: 'Native Hawaiian or Other Pacific Islander'},
    {value: 'White', label: 'White'},
    {value: 'Two or More Races', label: 'Two or More Races'},


];
var usmsOptions = [
    {value: 'Never served', label: 'Never served'},
    {value: 'Current servicemember', label: 'Current servicemember'},
    {value: 'Former member of the military', label: 'Former member of the military'},
];
var workOptions = [
    {value: '1', label: 'Freshman'},
    {value: '2', label: 'Sophomore'},
    {value: '3', label: 'Junior'},
    {value: '4', label: 'Senior'},
    {value: '5', label: 'Masters'},
    {value: '6', label: 'Doctorate'},
    {value: '7', label: 'Postdoctoral Studies'},
    {value: '8', label: 'Recent Graduate'},
];

var work_authOptions = [
    {value: '1', label: 'U.S. Citizen'},
    {value: '2', label: 'Permanent U.S. Resident'},
    {value: '3', label: 'Employment (H-1) Visa'},
    {value: '4', label: 'L1 Visa'},
    {value: '5', label: 'Work Card'},
    {value: '6', label: 'Student (F-1) Visa'},
    {value: '7', label: 'J-1 Visa (Exchange Program)'},
    {value: '8', label: 'TN Visa'},
    {value: '9', label: 'H4 Visa'},
];

const locOptions = [{value: "", label: ''}];

//var termArr = [];
class ProfileExtra extends React.Component {
    constructor(props) {
        super(props);


        var my = false;
        var _this;
        if (this.props.user.id_account == this.props.profileId) {
            my = true;
        }

        this.state = {profileId: this.props.profileId, loading: false, my: my, item: {}, extra: {}, show: false};

        _this = this;

        //profileId = this.props.profileId;
        //this.getCourses = this.getCourses.bind(this);
    }


    componentDidMount() {
        this.setState({loading: true});
        this.getUserExtra();


    }

    componentWillReceiveProps(nextProps) {
        var my = nextProps.my;

        var loading = false;
        if (nextProps.profileId != this.props.profileId) {
            loading = true;
        }
        if (loading) {
            this.setState({loading: loading, profileId: nextProps.profileId, my: my, extra: {}}, () => {
                this.getUserExtra();
            });
        }
        else {
            this.setState({loading: loading, profileId: nextProps.profileId, my: my});
        }


        //profileId = nextProps.profileId;

    }


    getUserExtra() {
        axios.get(commonApi.getAPIURL() + '?api=getUserExtra&user_id=' + this.state.profileId)
            .then(response => {
                if (response.data.status == 1) {
                    this.setState({locOptions: [{value: response.data.data.office, label: response.data.data.office}]});
                    this.setState({extra: response.data.data});
                    //store.dispatch(getUserSuccess(response.data.data));
                }
                this.setState({loading: false});
                //console.log(response.data);
                return response;
            });
    }


    add(e) {
        this.getUserExtra();
        var item = this.state.extra;

        this.setState({show: true, item: item});
    }

    cancel(e) {
        this.setState({show: false});
    }


    save(e) {
        var item = this.state.item;
        if (item.gender == undefined || item.gender.trim().length == 0) {

            item.gender = 0
        }
        if (item.ethnicity == undefined || item.ethnicity.trim().length == 0) {

            commonApi.showAlert("Please select ethnicity");
            return;
        }
        if (item.usms == undefined || item.usms.trim().length == 0) {

            commonApi.showAlert("Please select US Military Service");
            return;
        }
        if (item.work == undefined || item.work.trim().length == 0) {

            commonApi.showAlert("Please select student type?");
            return;
        }


        var data = new FormData();

        data.append('gender', item.gender);
        data.append('ethnicity', item.ethnicity);
        data.append('usms', item.usms);
        data.append('car', item.car);
        data.append('work', item.work);
        data.append('work_auth', item.work_auth);
        data.append('office', item.office);

        axios.post(commonApi.getAPIURL() + '?api=updateUserExtra', data)
            .then(response => {
                if (response.data.status == 1) {
                    this.setState({show: false, item: {}});
                    this.getUserExtra();
                }

                //console.log(response.data);

                return response;
            }).catch(error => {

        });


    }


    genderChange(it) {
        var item = this.state.item;
        item.gender = it.value;
        this.setState({item: item});
    }

    ethChange(it) {
        var item = this.state.item;
        item.ethnicity = it.value;
        this.setState({item: item});
    }

    usmsChange(it) {
        var item = this.state.item;
        item.usms = it.value;
        this.setState({item: item});
    }

    carChange(it) {
        var item = this.state.item;
        item.car = it.value;
        this.setState({item: item});
    }

    workChange(it) {
        var item = this.state.item;
        item.work = it.value;
        this.setState({item: item});
    }

    work_authChange(it) {
        var item = this.state.item;
        item.work_auth = it.value;
        this.setState({item: item});
    }

    getLocationOptions(input, callback) {
        if (input.length == 0) {
            //this.setState({ location: "" });
            // callback(null, {options: this.state.locOptions});
            this.setState({locOptions: this.state.locOptions})
        }
        else {
            var data = new FormData();
            data.append('search', input);
            axios.post(commonApi.getAPIURL() + '?api=searchJobLocation', data, {
                progress: (progressEvent) => {
                }
            })
                .then(response => {
                    if (response.data.status == 1) {
                        // callback(null, {options: response.data.data});
                        this.setState({locOptions: response.data.data})
                    } else {
                        // callback(null, {options: []});
                    }
                    return response;
                })
                .catch(error => {
                    // callback(null, {options: []});
                });
        }
    }

    handleLocationChange = (event) => {
        var item = this.state.item;
        item.office = event.value;
        this.setState({item: item});
    }

    findObjectByKey(array, key, value) {
        for (var i = 0; i < array.length; i++) {
            if (array[i][key] == value) {
                return array[i]['label'];
            }
        }
        return null;
    }

    render() {
        var work = "";
        if (this.state.extra.work) {
            work = this.findObjectByKey(workOptions, 'value', this.state.extra.work);
        }
        var work_auth = "";
        if (this.state.extra.work) {
            work_auth = this.findObjectByKey(work_authOptions, 'value', this.state.extra.work_auth);
        }

        return (
            <div
                className={this.state.my && Object.keys(this.state.extra).length > 0 && this.state.loading == false ? "page_course_box profile_content_wrapper" : "hide-el"}
                style={{position: 'relative'}}>
                <div className="title_box">
                    <img src="/static/img/appimg/icon_info.png"/>
                    <div className="title">
                        Extra Information
                    </div>
                </div>
                <a style={{position: 'absolute', top: '12px', right: '10px'}} onClick={this.add.bind(this)}><img
                    src="/static/img/appimg/email-icon03.png"/></a>
                {this.state.show == true ? (
                    <div>
                        <div style={{fontSize: '9pt'}}><b>Demograpic Info</b></div>

                        <div><b>Gender</b>
                            <div><Select
                                name="gender"
                                value={this.state.item.gender}
                                options={genderOptions}
                                onChange={this.genderChange.bind(this)}
                                clearable={false}
                                searchable={false}
                            /></div>
                        </div>
                        <div><b>Ethnicity</b>
                            <div><Select
                                name="eth"
                                value={this.state.item.ethnicity}
                                options={ethOptions}
                                onChange={this.ethChange.bind(this)}
                                clearable={false}
                                searchable={false}
                            /></div>
                        </div>
                        <div><b>US Military Service</b>
                            <div><Select
                                name="us"
                                value={this.state.item.usms}
                                options={usmsOptions}
                                onChange={this.usmsChange.bind(this)}
                                clearable={false}
                                searchable={false}
                            /></div>
                        </div>

                        <div><b>Student Type</b>
                            <div><Select
                                name="car"
                                value={this.state.item.work}
                                options={workOptions}
                                onChange={this.workChange.bind(this)}
                                clearable={false}
                                searchable={false}
                            /></div>
                        </div>

                        <div><b>Work Authorization</b>
                            <div><Select
                                name="work_auth"
                                value={this.state.item.work_auth}
                                options={work_authOptions}
                                onChange={this.work_authChange.bind(this)}
                                clearable={false}
                                searchable={false}
                            /></div>
                        </div>
                        <div><b>Current Location</b>
                            <div>
                                <Select
                                    name="office"
                                    value={this.state.item.office}
                                    options={this.state.locOptions}
                                    onChange={this.handleLocationChange.bind(this)}
                                    placeholder=""
                                    onInputChange={this.getLocationOptions.bind(this)}
                                    noResultsText=""
                                    clearable={false}
                                    searchable={true}
                                    className="select_box"
                                    style={{marginBottom: '10px'}}
                                />
                            </div>
                        </div>
                        <div style={{fontSize: '7pt', color: 'gray'}}><img
                            src="/static/img/appimg/icon_privacy.png"/> Extra infomation will only be visible to
                            employers when you apply to a job. It's hidden from the public.
                        </div>
                        <div className="inline_block">
                            <a onClick={this.save.bind(this)} style={{padding: '9px 15px'}}
                               className="btn_v btn_confirm fright">Save</a>
                            <a onClick={this.cancel.bind(this)} style={{padding: '9px 15px', marginRight: '5px'}}
                               className="btn_v btn_cancel fright">Cancel</a>
                        </div>
                    </div>
                ) : (<div>

                        <div style={{fontSize: '9pt'}}>

                            <div><b>Demograpic Info</b></div>
                            <div className="inline_block">
                                <div className="div_50 center">
                                    <b>Gender</b><br/>{this.state.extra.gender == 0 ? "Male" : "Female"}</div>
                                <div className="div_50 center"><b>Ethnicity</b><br/>{this.state.extra.ethnicity}</div>
                            </div>
                            <div><b>US Military Service</b><br/>{this.state.extra.usms}</div>
                            <div><b>Student Type</b><br/>{work}</div>
                            <div><b>Work Authorization</b><br/>{work_auth}</div>
                            <div><b>Current Location</b><br/>{this.state.extra.office}</div>

                        </div>
                    </div>
                )}


            </div>

        )
    }
}

export default ProfileExtra;


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/commons/profile/profile_extra.js
 **/